__turbopack_context__.v({
  "cardTags": "style-module-scss-module__kZDP1G__cardTags",
  "tag": "style-module-scss-module__kZDP1G__tag",
});
